module.exports = __webpack_public_path__ + "img/logo3.e430ef68.png";